var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.departments,"item-text":"Navn","item-value":"AvdelingId","loading":!_vm.departments,"outlined":"","dense":"","label":_vm.$t('department')},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }